module.exports = __webpack_public_path__ + "img/9791185502595.b6a39ea3.jpg";